import { defineMessages } from 'react-intl';


export default defineMessages({
    SUB_TITLE: {
        id: 'InsCommon.ConfirmationPage.SubTitle',
        defaultMessage: 'Use the phone number provided to speak with a verified insurance expert today. Don\'t forget to reference your quote id when calling in.',
    },

    // Shared only in home and condo
    PERSONAL_PROPERTY: {
        id: 'InsCommon.ConfirmationPage.PersonalProperty',
        defaultMessage: 'Personal property',
    },
    PERSONAL_LIABILITY: {
        id: 'InsCommon.ConfirmationPage.PersonalLiability',
        defaultMessage: 'Personal liability',
    },
    CLAIMS_DEDUCTIBLE: {
        id: 'InsCommon.ConfirmationPage.ClaimsDeductible',
        defaultMessage: 'Claims deductible',
    },
    ENDORSEMENTS: {
        id: 'InsCommon.ConfirmationPage.Endorsements',
        defaultMessage: 'Endorsements',
    },
    
    // Policy information section
    POLICY_INFO_HEADING: {
        id: 'InsCommon.ConfirmationPage.PolicyInfo',
        defaultMessage: 'Policy information',
    },
    QUOTE_ID_LABEL: {
        id: 'InsCommon.ConfirmationPage.QuoteIdLabel',
        defaultMessage: 'Quote ID',
    },
    PROVIDER_LABEL: {
        id: 'InsCommon.ConfirmationPage.ProviderLabel',
        defaultMessage: 'Provider',
    },
    POLICY_LENGTH_LABEL: {
        id: 'InsCommon.ConfirmationPage.PolicyLengthLabel',
        defaultMessage: 'Policy length',
    },
    MONTHLY_PAYMENT_LABEL: {
        id: 'InsCommon.ConfirmationPage.MonthlyPaymentLabel',
        defaultMessage: 'Monthly payment',
    },
    TOTAL_POLICY_FEE_LABEL: {
        id: 'InsCommon.ConfirmationPage.TotalPolicyFeeLabel',
        defaultMessage: 'Total policy fee',
    },

    // Coverage information section
    COVERAGE_INFO_HEADING: {
        id: 'InsCommon.ConfirmationPage.CoverageInfo',
        defaultMessage: 'Coverage information',
    },

    // Contact information section
    ADDRESS_LABEL: {
        id: 'InsCommon.ConfirmationPage.Address',
        defaultMessage: 'Address',
    },
});